module.exports = __webpack_public_path__ + "img/project-2.e08f13cd.jpg";